<div
  [ngClass]="[
    'p-flight-detail01__item p-flight-detail01__item--2col p-flight-detail01__item--arrival',
    tripSummarySvc.isOtherClass(flight.operatingAirlineCode),
    tripSummarySvc.isChangeClass(flight.arrival?.estimatedDateTime)
  ]"
>
  <!-- (1.1.48) 到着時刻 - 以下の条件に応じて表示する。-->
  <div class="p-flight-detail01__time">
    <!-- (1.1.48) 到着時刻 - 1) 当該セグメント情報.isOpenSegment=true(OPEN便)の場合、未定の旨を表示する。 -->
    <div *ngIf="flight.isOpenSegment; else arrivalBlock" class="p-flight-detail01__time-item">
      <span
        class="p-flight-detail01__time-stamp"
        [attr.aria-label]="'reader.DepartureChangeAfterTime' | staticMsg"
        [innerHTML]="'label.hyphen' | staticMsg"
      ></span>
    </div>
    <!-- (1.1.48) 到着時刻 - 2) 上記以外の場合、当該セグメント情報.arrival.dateTimeを表示する。-->
    <ng-template #arrivalBlock>
      <!-- (1.1.16) セグメント情報 (2.5) -->
      <div class="p-flight-detail01__time-item" *ngIf="!flight.arrival?.estimatedDateTime; else estimatedDateTimeBlock">
        <span
          class="p-flight-detail01__time-stamp"
          [innerHTML]="flight.arrival?.dateTime || '' | dateFormat : 'default_departuredate.time'"
        ></span>
      </div>
      <!-- (1.1.48) 到着時刻 - ※当該セグメント情報.arrival.estimatedDateTimeが存在する場合、取り消し線で表示する。-->
      <ng-template #estimatedDateTimeBlock>
        <!-- (1.1.50) 最新到着時刻 -->
        <asw-estimate-datetime
          [newDateTime]="flight.arrival?.estimatedDateTime ?? ''"
          [oldDateTime]="flight.arrival?.dateTime ?? ''"
          [isArrival]="true"
        ></asw-estimate-datetime>
      </ng-template>
    </ng-template>
  </div>
  <div class="p-flight-detail01__detail">
    <div class="p-flight-detail01__detail-item">
      <!-- (1.1.52) 到着地 & (1.1.16) セグメント情報 (2.4) -->
      <p
        class="p-flight-detail01__detail-airport"
        [innerHTML]="getArrivalLocationName(flight.arrival?.locationCode, flight.arrival?.locationName)"
      ></p>
      <!-- (1.1.53) 到着ターミナル -->
      <p
        *ngIf="!flight.isOpenSegment"
        class="p-flight-detail01__detail-terminal"
        [innerHTML]="
          tripSummarySvc.getTerminalAndGate(
            flight.isNhGroupOperated,
            flight.arrival?.locationCode,
            flight.arrival?.terminal
          )
        "
      ></p>
    </div>
  </div>
</div>
